module.exports = __webpack_public_path__ + "img/step3-c.f79935a5.png";